export default __webpack_public_path__ + "static/media/wechat.b73e171e.svg";